
import React, { useState, useEffect, Fragment } from 'react';
import moment from 'moment'
import EventList from './components/EventList'
import {UsersProvider} from './contexts/UsersContext'
import {LoginProvider} from './contexts/LoginContext'
import {ErrorProvider} from './contexts/ErrorContext'
import {EventsProvider} from './contexts/EventsContext'
import {CommentsProvider} from './contexts/CommentsContext'
import ErrorMessage from './components/ErrorMessage'
import PeriodSelector from './components/PeriodSelector'
import ManualEvent from './components/ManualEvent'
import Login from './components/Login'
import ClipLoader from "react-spinners/ClipLoader";
import CurrentPosition from './components/CurrentPosition'
import api from './data-source/api';

import './App.css';

function App() {
  
  const [year, setYear] = useState(moment().format('YYYY'))
  const [month, setMonth] = useState("All")
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(false)
  const [login,setLogin] = useState(null)
  

  useEffect( () => {
    if(error) console.log(error);
  },[error])

  const Loading = () => error ? <Fragment/> : <span>Loading events.... Please Wait...</span>

  if(api.expenseFormType && api.expenseFormList){
    return(
      <ErrorProvider error={error}>
        <LoginProvider errorHandler={setError} onChange={setLogin}>
          <UsersProvider errorHandler={setError}>
          </UsersProvider>
        </LoginProvider>
      </ErrorProvider>  
    );
  }

  
  return (
    <ErrorProvider error={error}>
      <LoginProvider errorHandler={setError} onChange={setLogin}>
        <UsersProvider errorHandler={setError}>
          <EventsProvider year={year} month={month} loadingStateHandler={setLoading} errorHandler={setError} >
            <CommentsProvider year={year} month={month} errorHandler={setError}>
              <div className="App container">
                <div className="row">
                  <div className="col-sm">
                    {error ? <ErrorMessage message={error.message}/> : <Fragment/>}
                    {login && (login.isAdmin || login.isActiveMember) ? <ManualEvent/> : <Fragment/>}
                    {login && api.trackerId && (login.isAdmin || login.isActiveMember) ? <CurrentPosition errorHandler={setError}/> : <Fragment/>}
                    {loading ? <Loading/> : <Fragment/>}
                    <div className="card" style={{marginTop: "2.5rem"}}>
                      <nav className="navbar navbar-expand-lg bg-light navbar-light" style={{lineHeight: "2.5"}}>
                        <ul className="nav flex-column flex-sm-row event-list">
                        <li className="nav-item">
                          <PeriodSelector year={year} setYear={setYear} month={month} setMonth={setMonth} disabled={loading} errorHandler={setError}/>
                          <ClipLoader css={`display: inline-flex; vertical-align: middle; margin: 5px;`} size={30} loading={loading && !error}/> 
                        </li>
                        <li className="nav-item"><Login/></li>  
                        </ul>
                      </nav>
                      <EventList errorHandler={setError}/>
                      
                    </div>
                  </div>
                </div>
              </div>
            </CommentsProvider>
          </EventsProvider>
        </UsersProvider>
      </LoginProvider>
    </ErrorProvider>
  );
  

  
  
}

export default App;
